const createPubSub = () => {
  const listeners = new Set()
  return {
    subscribe: (cb) => { listeners.add(cb) },
    unsubscribe: (cb) => listeners.delete(cb),
    publish: (data) => listeners.forEach((cb) => cb(data))
  }
}

const { publish, ...pubsub } = createPubSub()

const baseRoute = 'initial'
let currentView = baseRoute

const onChangeRoute = (newRoute) => {
  currentView = newRoute ?? baseRoute
  publish(currentView)
}

export default {
  ...pubsub,
  current: () => currentView,
  toggleCart: (state) => {
    onChangeRoute(state ? 'cart' : undefined)
  },
  toggleMenu: (state) => {
    onChangeRoute(state ? 'menu' : undefined)
  },
}
